// Conteúdo de ajuda por aba + passos do tutorial do primeiro acesso.
// Usado por components/OnboardingHelp.js

export const HELP_CONTENT = {
  "/": {
    title: "Dashboard",
    desc: "Visão geral do negócio em tempo real: faturamento, vendas do dia, ticket médio e comparativos entre as lojas. Use esta tela para acompanhar rapidamente como o dia e o mês estão indo.",
  },
  "/crm": {
    title: "CRM Contatos",
    desc: "Cadastre e acompanhe os contatos/leads de cada loja. O sistema avisa quando um contato está há 2 dias ou mais sem retorno, ajudando a não perder nenhuma oportunidade de venda.",
  },
  "/agenda": {
    title: "Agenda",
    desc: "Organize os agendamentos (consultas, entregas, retornos) por dia e por loja. Clique em um dia para ver e adicionar compromissos.",
  },
  "/conferencia-caixa": {
    title: "Fechamento de Caixa",
    desc: "Confira e feche o caixa do dia por loja. O sistema soma automaticamente as vendas por forma de pagamento; aqui você confere com o valor real e registra o fechamento.",
  },
  "/receitas": {
    title: "Vendas",
    desc: "Lista de todas as vendas/receitas registradas, com filtros por período e loja. Edite, acompanhe o status de produção e, se necessário, mova uma venda para a lixeira (o estoque e o catálogo são repostos automaticamente ao excluir).",
  },
  "/receitas/nova": {
    title: "Nova Receita",
    desc: "Registre uma nova venda. Preencha os dados do cliente, o tipo de produto e a graduação. Para armações e óculos de sol, use 'Selecionar do Catálogo' para preencher referência e preço automaticamente — a peça sai do estoque e da vitrine ao concluir.",
  },
  "/metas": {
    title: "Metas",
    desc: "Defina e acompanhe as metas de faturamento por loja e por período. O progresso aparece aqui e também nas notificações quando a meta está próxima ou foi atingida.",
  },
  "/relatorio-lentes": {
    title: "Relatório de Lentes",
    desc: "Relatório detalhado das lentes vendidas, útil para acerto com laboratórios e análise de mix. Filtre por período e loja.",
  },
  "/estoque": {
    title: "Estoque",
    desc: "Controle a quantidade de cada categoria por loja, faça transferências entre lojas e consulte o 'Relatório de peças vendidas (catálogo)' com referência, OS, cliente, loja e data. A baixa de estoque acontece automaticamente a cada venda.",
  },
  "/premiacao-lentes": {
    title: "Premiação de Lentes",
    desc: "Acompanhe as faixas de premiação por vendas de lentes, por loja. Serve para motivar e reconhecer a equipe conforme o volume vendido.",
  },
  "/catalogo": {
    title: "Catálogo",
    desc: "Monte a vitrine digital de cada loja. Adicione fotos (a IA deixa o fundo branco automaticamente, inclusive em fotos de iPhone), organize por abas 'Ativos' e 'Ocultos/Vendidos', reexiba peças e use 'Ver / Compartilhar' para copiar o link público para enviar aos clientes.",
  },
  "/kanban": {
    title: "Mensagens",
    desc: "Central de mensagens e acompanhamento de atendimentos em formato de quadro (Kanban). Organize as conversas por etapa.",
  },
  "/executivo-mensal": {
    title: "Executivo Mensal",
    desc: "Relatório executivo consolidado do mês: visão gerencial de resultados, tendências e comparativos entre lojas para apoiar decisões.",
  },
  "/anexos": {
    title: "Anexos",
    desc: "Armazene e consulte documentos e arquivos importantes vinculados à operação (comprovantes, contratos, imagens).",
  },
  "/configuracoes": {
    title: "Configurações",
    desc: "Ajuste as preferências do sistema, o tema visual e a lista de lojas. As lojas cadastradas aqui aparecem automaticamente em todas as telas (vendas, metas, CRM, agenda, estoque e catálogo).",
  },
};

// Passos do tutorial do primeiro acesso, na mesma ordem do menu lateral.
export const TUTORIAL_STEPS = [
  { title: "Bem-vindo(a) ao Óticas Laurindo! 👓", desc: "Este rápido tutorial apresenta cada aba do sistema. A qualquer momento você pode tocar no botão de ajuda (?) no canto inferior direito para rever a explicação da aba em que estiver." },
  { title: "Nova Receita", desc: HELP_CONTENT["/receitas/nova"].desc },
  { title: "Dashboard", desc: HELP_CONTENT["/"].desc },
  { title: "CRM Contatos", desc: HELP_CONTENT["/crm"].desc },
  { title: "Agenda", desc: HELP_CONTENT["/agenda"].desc },
  { title: "Fechamento de Caixa", desc: HELP_CONTENT["/conferencia-caixa"].desc },
  { title: "Vendas", desc: HELP_CONTENT["/receitas"].desc },
  { title: "Metas", desc: HELP_CONTENT["/metas"].desc },
  { title: "Relatório de Lentes", desc: HELP_CONTENT["/relatorio-lentes"].desc },
  { title: "Estoque", desc: HELP_CONTENT["/estoque"].desc },
  { title: "Premiação de Lentes", desc: HELP_CONTENT["/premiacao-lentes"].desc },
  { title: "Catálogo", desc: HELP_CONTENT["/catalogo"].desc },
  { title: "Mensagens", desc: HELP_CONTENT["/kanban"].desc },
  { title: "Executivo Mensal", desc: HELP_CONTENT["/executivo-mensal"].desc },
  { title: "Anexos", desc: HELP_CONTENT["/anexos"].desc },
  { title: "Configurações", desc: HELP_CONTENT["/configuracoes"].desc },
  { title: "Tudo pronto! ✅", desc: "Você concluiu o tutorial. Comece registrando uma venda em 'Nova Receita' ou explore o menu à esquerda. Precisa de ajuda em alguma aba? É só tocar no botão (?) no canto inferior direito." },
];
